import { queryOptions, useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/client'

export const organizationAgentsQueryKeys = {
  all: (organizationId: string) =>
    ['organization-agents', organizationId] as const,
  list: (organizationId: string) =>
    [...organizationAgentsQueryKeys.all(organizationId), 'list'] as const,
  detail: (organizationId: string, agentId: string) =>
    [
      ...organizationAgentsQueryKeys.all(organizationId),
      'detail',
      agentId,
    ] as const,
  tools: (organizationId: string) =>
    [...organizationAgentsQueryKeys.all(organizationId), 'tools'] as const,
}

export const agentTemplatesQueryKeys = {
  list: (organizationId: string, language: 'ru' | 'en') =>
    ['agent-templates', organizationId, language] as const,
}

export function agentTemplatesQueryOptions(
  organizationId: string,
  language: 'ru' | 'en',
) {
  return queryOptions({
    queryKey: agentTemplatesQueryKeys.list(organizationId, language),
    queryFn: () =>
      apiClient.organizations.agents.listTemplates(organizationId, language),
  })
}

export function organizationAgentsQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: organizationAgentsQueryKeys.list(organizationId),
    queryFn: () => apiClient.organizations.agents.list(organizationId),
  })
}

export function organizationAgentQueryOptions(
  organizationId: string,
  agentId: string,
) {
  return queryOptions({
    queryKey: organizationAgentsQueryKeys.detail(organizationId, agentId),
    queryFn: () => apiClient.organizations.agents.get(organizationId, agentId),
  })
}

export function organizationAgentToolsQueryOptions(organizationId: string) {
  return queryOptions({
    queryKey: organizationAgentsQueryKeys.tools(organizationId),
    queryFn: () => apiClient.organizations.agents.tools(organizationId),
  })
}

export function useOrganizationAgentsQuery(organizationId: string | undefined) {
  return useQuery({
    ...organizationAgentsQueryOptions(organizationId ?? ''),
    enabled: Boolean(organizationId),
  })
}

export function useAgentTemplatesQuery(
  organizationId: string | undefined,
  language: 'ru' | 'en',
) {
  return useQuery({
    ...agentTemplatesQueryOptions(organizationId ?? '', language),
    enabled: Boolean(organizationId),
  })
}

export function useOrganizationAgentToolsQuery(
  organizationId: string | undefined,
) {
  return useQuery({
    ...organizationAgentToolsQueryOptions(organizationId ?? ''),
    enabled: Boolean(organizationId),
  })
}
